import {axiosInstance} from "../helpers/axios";

const saveSolicitudFinish = (data) => {
    return axiosInstance.post('saveSolicitudFinish/', data ).then((res) => {
        const data = res.data;
        return data;
    }).
    catch(err => {
        console.log("error");
        console.log(err.message);
    });
}

export default { saveSolicitudFinish };